import React from "react";
import { Box, Typography } from "@mui/material";
import FormInput from "@/components/FormInput";
import {
  calculateTotalNominalPower,
  calculateTotalUsableCapacity,
} from "@/utils/calculateTotalNominalPower";

interface BatteryCalculationsSectionProps {
  formInstance: any;
}

export const BatteryCalculationsSection: React.FC<
  BatteryCalculationsSectionProps
> = ({ formInstance }) => {
  const batteryQuantity = formInstance.watch("batteryQuantity");
  const individualBatteryCapacity = formInstance.watch("usableCapacity");
  const nominalPower = formInstance.watch("nominalPower");

  const totalBatteryUsableCapacity = calculateTotalUsableCapacity(
    individualBatteryCapacity,
    batteryQuantity
  );
  const totalNominalPower = calculateTotalNominalPower(
    nominalPower,
    batteryQuantity
  );
  formInstance.setValue(
    "totalBatteryUsableCapacity",
    totalBatteryUsableCapacity
  );
  formInstance.setValue("totalNominalPower", totalNominalPower);

  return (
    <>
      <Box sx={{ mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography
            sx={{ fontSize: "12px", fontWeight: 500, color: "#373533" }}
          >
            Total Usable Capacity (kWh)
          </Typography>
        </Box>
        <FormInput
          name="totalBatteryUsableCapacity"
          control={formInstance.control}
          label=""
          disabled={true}
        />
        <Typography
          sx={{
            fontSize: "11px",
            color: "#666",
            marginTop: "4px",
          }}
        >
          Individual battery capacity in kWh. When quantity is set, this will
          show the total capacity.
        </Typography>
      </Box>

      <Box sx={{ mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography
            sx={{ fontSize: "12px", fontWeight: 500, color: "#373533" }}
          >
            Total Nominal Power (kW)
          </Typography>
        </Box>
        <FormInput
          name="totalNominalPower"
          control={formInstance.control}
          label=""
          disabled={true}
        />
        <Typography
          sx={{
            fontSize: "11px",
            color: "#666",
            marginTop: "4px",
          }}
        >
          Individual battery nominal power in kWh. When quantity is set, this
          will show the total nominal power.
        </Typography>
      </Box>
    </>
  );
};

export default BatteryCalculationsSection;
